import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, onMounted, reactive, ref, toRefs, watch } from "vue";
import { useRouter } from "vue-router";
import { USERINFO } from "@/store/mutation-types";
import apis from "@/api";
import dayjs from "dayjs";
import common from "../composables/common";
import { DArrowRight } from '@element-plus/icons-vue';
import MyUpload from './UpLoad';
import _ from 'lodash';
import SensitiveWordsDialog from "../components/SensitiveWordsDialog";
export default {
  name: "AddFinished",
  components: {
    SensitiveWordsDialog,
    DArrowRight,
    MyUpload
  },
  setup(props, ctx) {
    const {
      commonData,
      defaultRangeTime,
      disabledDate
    } = common();
    const router = useRouter();
    const treeLeft = ref(null);
    const maxHeight = ref('100%');
    const formRef = ref(null);
    const positionLoading = ref(false);
    const userInfo = ref({});
    const fileDialogShow = ref(false);
    const defaultProps = {
      children: "children",
      label: "label",
      disabled: (data, node) => node.childNodes && node.childNodes.length > 0
    };
    const data = reactive({
      filterText: '',
      fileList: [],
      posTree: [],
      defaultPosChecked: [],
      positionsTemp: [],
      positions: [],
      demand: {},
      currentPosition: {},
      upLoading: false,
      rules: {
        name: [{
          required: true,
          message: "请输入素材名称",
          trigger: "blur"
        }],
        validDate: [{
          required: true,
          message: "请选择素材有效期",
          trigger: "blur"
        }],
        position: [{
          validator: validatePosition,
          trigger: "blur"
        }]
      }
    });
    function validatePosition(rule, value, callback) {
      if (data.positions.length <= 0) {
        callback(new Error("请选择运营位"));
      } else {
        callback();
      }
    }
    watch(() => data.filterText, value => {
      treeLeft.value.filter(value);
    });
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    const handleCheck = async () => {
      let newPositions = [];
      let nodes = treeLeft.value.getCheckedNodes(true);
      for (const node of nodes) {
        newPositions.push({
          positionId: node.id,
          labels: node.labels,
          label: node.label,
          topId: node.topId,
          positionAllname: node.labels,
          files: []
        });
      }
      data.positionsTemp = newPositions;
    };
    const initPositions = () => {
      positionLoading.value = true;
      apis.queryPositionTree("").then(res => {
        if (res.success) {
          data.posTree = _.filter(res.data, o => o.id !== '003');
        } else {
          ElMessage.error(res.msg);
        }
        positionLoading.value = false;
      }).catch(() => positionLoading.value = false);
    };
    const left2right = () => {
      data.positions = data.positionsTemp;
      if (data.positionsTemp && data.positionsTemp.length > 0) {
        data.demand.positionFlag = data.positionsTemp[0].id;
      } else {
        data.demand.positionFlag = '';
      }
    };
    const getUserInfo = () => {
      const user = JSON.parse(window.localStorage.getItem(USERINFO));
      if (user.depName) {
        user.deptName = _.replace(user.depName, '组织机构/', '');
      }
      userInfo.value = user;
    };
    const removePosition = (index, postionId) => {
      data.positions.splice(index, 1);
      treeLeft.value.setChecked(postionId, false, false);
    };
    const removeFile = index => {
      data.currentPosition.files.splice(index, 1);
    };
    const clearPosSelected = () => {
      data.positions = [];
      treeLeft.value.setCheckedKeys([]);
    };
    onMounted(() => {
      initPositions();
      getUserInfo();
      const validDate = [dayjs().set('hour', 0).set('minute', 0).set('second', 0), dayjs().add(1, 'year').set('hour', 23).set('minute', 59).set('second', 59)];
      data.demand.validDate = validDate;
      maxHeight.value = document.getElementById('posTree').clientHeight + 'px';
    });
    const handlerUpload = (index, item) => {
      fileDialogShow.value = true;
      data.currentPosition = item;
    };
    const handlerUploadSuccess = fileList => {
      data.currentPosition.files = data.currentPosition.files.concat(fileList);
      fileDialogShow.value = false;
    };
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          data.demand.validDateBgn = dayjs(data.demand.validDate[0]).format("YYYY-MM-DD HH:mm:ss");
          data.demand.validDateEnd = dayjs(data.demand.validDate[1]).format("YYYY-MM-DD HH:mm:ss");
          data.demand.belongDepart = 'shichang';
          data.demand.positions = data.positions;
          let assetsList = [];
          data.positions.forEach(p => {
            p.files.forEach(f => {
              f.positionId = p.positionId;
              f.srcId = f.id;
              f.positionTopId = p.topId;
              f.srcName = f.fileName;
              f.srcTyp = '1';
              f.srcInnUrl = f.relativeUrl;
              f.srcSize = f.fileResolution;
              f.srcFileLength = f.size;
              f.bgnDate = dayjs(data.demand.validDate[0]).format("YYYY-MM-DD HH:mm:ss");
              f.endDate = dayjs(data.demand.validDate[1]).format("YYYY-MM-DD HH:mm:ss");
              assetsList.push(f);
            });
          });
          const demandModel = {
            baseInfo: data.demand,
            assetsList: assetsList
          };
          console.log('addFinished-demandModel', demandModel);
          data.upLoading = true;
          apis.addFinished(demandModel).then(res => {
            if (res.success) {
              router.push("/my-needs/list");
            } else {
              ElMessage.error(res.msg);
            }
            data.upLoading = false;
          }).catch(() => {
            ElMessage.error('成品物料添加失败，请联系管理员');
            data.upLoading = false;
          });
        }
      });
    };
    const getAssetsIds = computed(() => {
      let assetsIds = [];
      data.positions.forEach(p => {
        p.files.forEach(f => {
          assetsIds.push(f.id);
        });
      });
      return assetsIds;
    });
    return {
      ...toRefs(data),
      ...toRefs(commonData),
      userInfo,
      disabledDate,
      defaultRangeTime,
      filterNode,
      handleCheck,
      defaultProps,
      left2right,
      clearPosSelected,
      handlerUpload,
      removePosition,
      removeFile,
      fileDialogShow,
      handlerUploadSuccess,
      treeLeft,
      handleSubmit,
      positionLoading,
      formRef,
      maxHeight,
      getAssetsIds
    };
  }
};